import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';

import { PromotionCard } from '../../account/promotion/PromotionCard';
import { useAuth } from '../../authentication/AuthenticationContext';
import { ActivatePromotion } from '../Activation.model';

interface Props {
  promotions: ActivatePromotion[];
}

export function ActivationClaim({ promotions }: Props): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();
  const { user } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <h3>
        {`${t('activation.welcome')} ${user.nickName}`}
      </h3>
      <h4 className='activation-title activation-success' data-cy='activation-success-label'>
        <CheckCircleIcon />
        {t('activation.titleClaim')}
      </h4>

      <div className='activation-content'>
        {promotions.map((promotion) => (
          <PromotionCard
            key={promotion.promotionId}
            activatePromotion={promotion}
          />
        )) }
      </div>

      <div className='activation-description'>
        <div className='question-circle-container activation-wizard'>
          <div className='question-mobile-container'>
            <div className='question-circle-node'>
              <div className='question-circle' data-content={t('activation.stepLogin')}>
                <CheckIcon />
              </div>
              <div className='question-line' />
            </div>
          </div>
          <div className='question-mobile-container'>
            <div className='question-circle-node'>
              <div className='question-circle' data-content={t('activation.stepActivation')}>
                <CheckIcon />
              </div>
              <div className='question-line' />
            </div>
          </div>
          <div className='question-mobile-container'>
            <div className='question-circle-node'>
              <div className='question-circle' data-content={t('activation.stepClaim')}>
                <CheckIcon />
              </div>
            </div>
          </div>
        </div>

        <div className='content'>
          <div>
            {t('activation.afterClaim.description')}
            <ul>
              <li>
                {t(
                  'activation.afterClaim.step1',
                  { rewardGame: t(`games.${promotions[0]?.relatedToGameId}`) },
                )}
              </li>
              <li>{t('activation.afterClaim.step2')}</li>
              <li>{t('activation.afterClaim.step3')}</li>
              <li>{t('activation.afterClaim.step4')}</li>
            </ul>
          </div>

          <p className='descriptionClaim'>
            {t('activation.descriptionClaim')}
          </p>
        </div>

        <button
          type='button'
          className='btn btn-primary-game'
          onClick={() => { history.push('/'); }}
          data-cy='activation-success-goToHome'
        >
          {t('button.return-home')}
        </button>
      </div>
    </>
  );
}
